import enIN from '@/locales/common/enIN';
import esMX from '@/locales/common/esMX';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { pushCleverTapEvent } from '@/component/shared/pushCleverTapEvent';

export default function ResourcesLinks() {
    const router = useRouter();
    const { locale } = router;
    const t = locale === 'es-mx' ? esMX : enIN;

    const [activeLink, setActiveLink] = useState('');

    useEffect(() => {
        const activeItem = t.ResLinks.find(item => {
            const basePath = item.link.split('?')[0];
            const currentBasePath = router.pathname.split('?')[0];
            return currentBasePath.startsWith(basePath);
        });
        
        if (activeItem) {
            setActiveLink(activeItem.link);
        }
    }, [router.pathname, t.ResLinks]);

    const handleLinkClick = (item) => {
        pushCleverTapEvent(item.eventsname, { PageName: item.PageName });
    };

    return (
        <div className="overflow-auto w-full">
            {t.ResLinks && (
                <ul className={`resourceTabsLinks flex justify-center md:justify-normal sm:justify-normal mb-[20px] ${locale === 'es-mx' ? 'sm:min-w-auto' : 'min-w-[600px]'}`}>
                    {t.ResLinks.map((item, index) => {
                        const isActive = activeLink === item.link || (router.pathname.includes('/blogs/category') && index === 0);
                        return (
                            <li key={index} className="px-1 border-r-0 last:border-r-0 first:px-0">
                                <Link
                                    href={item.link}
                                    target={item.target}
                                    className={`font-medium sm:px-[10px] min-w-[110px] text-center py-[7px] px-[10px] rounded-[5px] block ${isActive ? 'bg-brand text-yellowcolor' : 'text-brand'}`}
                                    onClick={() => handleLinkClick(item)}
                                >
                                    {item.name}
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
}
